/** Limits the number of map objects that can be imported in a single operation */
export const MAP_OBJECT_IMPORT_LIMIT = 20000;

/** Limits the number of layers and groups that can be imported in a single operation */
export const IMPORT_LAYERS_LIMIT = 100;

/** Limits the number of plans that can be copied in a single operation */
export const COPY_PLAN_LIMIT = 25;

/** Limits the number of layers that can be unlinked or copied in a single operation */
export const UNLINK_LAYERS_LIMIT = 100;

/** Limits the number of map objects that can be copied in a single operation */
export const MAP_OBJECT_COPY_LIMIT = 5000;
